import React, {useEffect, useRef, useState} from "react";
import {
    Box,
    Typography,
    Button,
    Container,
    makeStyles,
    Checkbox,
    CircularProgress,
    Grid,
    TextField,
    Card,
    Divider,
} from "@material-ui/core";
import Image from "material-ui-image";
import {ReactComponent as CheckboxBorder} from "../../../Images/checkboxBorder.svg";

import API from "../../../helpers/apiHelpers";
import {useSnackbar} from "notistack";
import {useHistory} from "react-router-dom";
import {getCreditRequests, reduceCreditsCount} from "../../../redux/credits/credits.actions";
import {setAllCards, setSelectedCard, changeAppointmentData, setIsCreditPayment } from "../../../redux/credits/credits.reducers";
import {RootState, useAppDispatch} from "../../../redux/store";
import {getVetSpecialtyFromPet} from "../../../Constants/specialities";
import {termsOfUseURL, privacyPolicyURL} from "../../../Constants/api";
import {useSelector} from "react-redux";
import {useTheme} from "@material-ui/core/styles";
import {
    postAppointmentRequest,
    setInvoicePreview,
    updatePaymentMethod,
    updatePromotionCode
} from "../../../redux/scheduleAppointment/scheduling.actions";
import moment from "moment";
import {jsPDF} from "jspdf";
import PaymentForm from "../../PaymentForm/PaymentForm";
import {ReactComponent as DocSVG} from "../../../Images/vetDoctor.svg";
import {setType} from "../../../Constants/serviceType";
import {getUserByID} from "../../../redux/user/user.actions";
import {getUserProfile} from "../../../redux/userProfile/userProfile.actions";
import {api_getTimeSlots} from "../../../redux/scheduleAppointment/scheduling.api";
import {colorError} from "../../../Constants/theme";
import {setPickedTimeSlot} from "../../../redux/scheduleAppointment/scheduling.reducers";
import useWindowSize from "../../../helpers/windowResizeHook";
import {partners} from "../../../Constants/partners";
import {api_getCreditPrices} from "../../../redux/credits/credits.api";
import {ensureSchedulePrice} from "../../../utils/guestBooking";

const useStyles = makeStyles({
    containerWrapper: {
        marginTop: "10vh",
    },
    promo: {
        margin: "20px 0"
    },
    promoBtn: {
        height: 45,
    },
    promoCancelBtn: {
        height: 45,
        backgroundColor: "red",
        color: "white"
    },
    input: {
        padding: "0.8rem 1rem"
    },
    newTimeSlot: {
        padding: 10,
        background: colorError,
        marginBottom: 10,
    },
});

const InvoiceAppointment = () => {
    const classes = useStyles();
    let history = useHistory();
    const myRef = useRef(null);
    const dispatch = useAppDispatch();
    const {enqueueSnackbar} = useSnackbar();
    const [vetPrice, setVetPrice] = useState("");
    const [totalPrice, setTotalPrice] = useState("");
    const [amountSubtracted, setAmountSubtracted] = useState("");
    const [totalWithPromo, setTotalWithPromo] = useState("");
    const [promo, setPromo] = useState("");
    const [promoApplied, setPromoApplied] = useState("");
    const [isPromoButtonDisabled, setIsPromoButtonDisabled] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [isInitialDataFetched, setIsInitialDataFetched] = useState(false);
    const [acknowledgedCall, setAcknowledgedCall] = useState(false);
    const [optionalCheckboxValue, setoptionalCheckboxValue] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRequestFinish, setIsRequestFinish] = useState(false);
    const [wasPromoApplied, setWasPromoApplied] = useState(false);
    const [creditPrice, setCreditPrice] = useState("");
    const [moneyApplied, setMoneyApplied] = useState("");
    const schedulingReducer = useSelector((state: RootState) => state?.scheduleAppointment);
    const selectedCard = useSelector((state: RootState) => state?.credits.selectedCard);
    const user = useSelector((state: RootState) => state?.user);
	const cards = useSelector((state: RootState) => state?.credits.allCards);
	const isCreditPayment = useSelector((state: RootState) => state?.credits.isCreditPayment);
	const appointmentData = useSelector((state: RootState) => state?.credits.appointmentData);
    const location = useSelector((state: RootState) => state?.common.location);
    const {
        pickedTimeSlot,
        additionalInfo,
        vetId,
        selectedPetId,
        serviceType,
        price,
        reasonType,
        immediate,
        paymentMethod,
        pdf,
        promo: promotionCode
    } = schedulingReducer;
    const total = +parseFloat(String(totalPrice).replace(/^\D+/g, ""));
    const [petName, setPetName] = useState("");
    const [pcvCheckBoxValue, setPCVCheckBoxValue] = useState(false);
    const [pcv, setPCV] = useState("no");
    const [hasSubscription, setHasSubscription] = useState(false);
    const [referralMoney, setReferralMoney] = useState(0.00);
    const [referralInvite, setReferralInvite] = useState(false);
    const [invitation, setInvitation] = useState<any>();
    //const [cards, setCards] = useState([]);
    const [isCustomer, setIsCustomer] = useState(null);
    const [isInPast, setIsInPast] = useState(false);
    const [subscription, setSubscription] = useState(undefined);
    const [creditsInfo, setCreditsInfo] = useState([]);
    const bundleType = schedulingReducer?.serviceType.includes("ADVICE") ? "ADVICE" : "DEFAULT";
    const isAdvice = bundleType === "ADVICE";
    const option = isAdvice ? "FOUR_ADVICE_CREDITS" : "FOUR_CREDITS";
    const formattedPickedTimeSlot = [`${pickedTimeSlot}[${moment.tz.guess()}]`];

    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const partnerId = useSelector((state: RootState) => state?.branding.partnerId);

    const iOS = () => {
        return [
            "iPhone Simulator",
            "iPod Simulator",
            "iPhone",
            "iPod",
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    };

    const checkTimeslot = (isNextTime = false) => (
        api_getTimeSlots(schedulingReducer.vetProfile.userId, moment( pickedTimeSlot[0]).format())
            .then((res) => {
                if (res.timeslotStatus === "BLOCKED" && res.nextAvailableTimeslot) {
                    dispatch(setPickedTimeSlot([res.nextAvailableTimeslot]));
                    setIsInPast(true);
                    return (true);
                } else {
                    return (false);
                }
            })
    );
    //This is for handling WITH_CREDITS or FREE only
    const handleButtonClick = async () => {
        setIsRequestFinish(true);
        setIsLoading(true);
        const total = +parseFloat(String(totalPrice).replace(/^\D+/g, ""));
        if (user.role !== "ADMIN" && total === 0) {
            const pet = await API.getAnimalById(selectedPetId);
            const specialty = getVetSpecialtyFromPet(pet);
            let requestBody: any = {
                animalId: selectedPetId,
                description: additionalInfo,
                chatId: Math.floor(Math.random() * 10001),
                timesRequested: formattedPickedTimeSlot,
                appointmentType: serviceType,
                vetSpecialty: specialty,
                state: location === false ? null : location,
                promotionCode,
            };
            if (schedulingReducer.funnelEmailGiftId) {
                requestBody.funnelEmailGiftId = schedulingReducer.funnelEmailGiftId;
            }

            if (wasPromoApplied && partnerId !== 13) {
                // @ts-ignore
                requestBody.promotionCode = promo;
            }
            if (pcvCheckBoxValue) {
                requestBody["isSendRecords"] = pcvCheckBoxValue;
            }
            if (!immediate) {
                // @ts-ignore
                requestBody.vetUserId = vetId;
            }
            if (paymentMethod === "WITH_CREDITS" && !hasSubscription) {
                const requests = await dispatch(getCreditRequests(bundleType));
                requestBody.creditRequestId = requests[0]?.id;
            } else {
                // @ts-ignore
                requestBody.paymentRequest = {
                    type: "square",
                    amount: "USD 0.00",
                    nonce: "no nonce needed"
                };
            }
            try {
                const apptRequest = await dispatch(postAppointmentRequest(requestBody));
                if (schedulingReducer.pdf !== "") {
                    let imgData = JSON.parse(schedulingReducer.pdf);
                    const pdf = new jsPDF();
                    pdf.addImage(imgData, "jpeg", 20 , 5, iOS() ? 130 : 170, iOS() ? 280 : 260, "consentForm", "NONE", 0);
                    //pdf.save("download.pdf");
                    const pdfParams = {
                        appointmentId: apptRequest.appointmentId,
                        clientId: user.userId,
                        imageUrl: "",
                        created: moment.utc().format(),
                        vetId: vetId
                    };
                    const firstStep = await API.addConsentForm(pdfParams).then(res => res.json());
                    const url = await API.getConsentURLs(firstStep.id);
                    const sendImage = await API.uploadConsentForm(url.uploadUrl, new Blob([pdf.output("blob")], {type: "application/pdf"}));
                }
                if (paymentMethod === "WITH_CREDITS" && !hasSubscription) dispatch(reduceCreditsCount());
                API.postAgreement({
                    type: "appointment_tos",
                    userId: user.userId,
                    appointmentId: apptRequest.appointmentId
                });
                API.postAgreement({
                    type: "appointment_privacy",
                    userId: user.userId,
                    appointmentId: apptRequest.appointmentId
                });
                setIsLoading(false);
                setIsRequestFinish(false);
                history.push({
                    pathname: "/appointmentConfirmation",
                    state: {
                        appointmentId: apptRequest.appointmentId,
                        total: "0",
                        type: apptRequest.appointmentType,
                    }
                });
            } catch (err) {
                setIsLoading(false);
                setIsRequestFinish(false);
                setAcknowledgedCall(false);
                if (err.nextDateStatus === "NOT_FOUND") history.push({pathname: "/availableVet", state: {redirect: true}})
                else {
                    if (err.nextAvailableTimeslot) {
                        dispatch(setPickedTimeSlot([err.nextAvailableTimeslot]));
                        setIsInPast(true);
                        myRef.current.scrollIntoView();
                    } else {
                        enqueueSnackbar("There was an error while processing your card. Your card has not been charged. Please refresh the page and try again.", {variant: "error"});
                    }
                }
            }
        }
    };

    useEffect(() => {
        (async () => {
            try {
                const customer = await API.getCustomers();
                setIsCustomer(customer);
                const profileCards = await API.getCreditCards();
                dispatch(setAllCards(profileCards));
            } catch (e) {
                setIsCustomer(false);
            }
        })();
    }, []);

	useEffect(()=>{
		(async () => {
			if(isCustomer === false){
				let  profile;
				if(user?.userId) {
					profile = await dispatch(getUserProfile({userId: user.userId}));
				}
				let body = {
					"givenName": profile[0].firstName || '',
					"familyName": profile[0].lastName || '',
					"companyName": "thevideovets",
					"emailAddress": user.email || '',
					"phoneNumber": profile[0].phoneNumber || ''
				}
				const data = await API.createCustomer(body);
			}
			const cardsInfo = await API.getCreditCards();
			dispatch(setAllCards(cardsInfo))
		})()
	}, [isCustomer])


    useEffect(()=>{
        if(cards.length){
            dispatch(setSelectedCard(cards.find(({isDefault}) => isDefault === true) || cards[0]));
        }
    },[cards])

    useEffect(() => {
        setAcknowledgedCall(false);
        (async () => {
            let subscription = false;
            const referralCash = await dispatch(getUserByID(user.userId)).then(res => {
                setReferralMoney(res.availableReferralCodeRequestAmount);
                if (res.ownerSubscriptionPlans?.length > 0) {
                    subscription = true;
                    setHasSubscription(true);
                }
                return res.availableReferralCodeRequestAmount;
            });
            const invite = await API.checkForReferralInvite().then(res => {
                if (res.length > 0) {
                    setReferralInvite(true);
                    setInvitation(res[0]);
                    return res[0];
                } else {
                    return undefined;
                }
            });
            const resolvedPrice = ensureSchedulePrice(dispatch, serviceType, price);
            if (!pickedTimeSlot.length || !additionalInfo || !selectedPetId || !resolvedPrice) {
                enqueueSnackbar("There was an error. Your card has not been charged. Please refresh the page and try again.", {variant: "error"});
                history.push("/schedule");
            } else {
                setIsLoading(true);
                const petType = API.getAnimalById(selectedPetId).then(pet => {
                    setPetName(pet.name);
                    if (Object.prototype.hasOwnProperty.call(pet, "primaryVetName") || Object.prototype.hasOwnProperty.call(pet, "primaryVetPhoneNumber")) {
                        if (pet.primaryVetName !== "" || pet.primaryVetPhoneNumber !== "") {
                            setPCV("yes");
                        }
                    }
                });
                const shouldAutoApplySub15 = subscription && reasonType === "PRESCRIPTION" && serviceType !== "RX_VIDEO";
                const promoBranch = shouldAutoApplySub15 ? "SUB15" : subscription || partnerId === 13 || sessionStorage.getItem("promoBranch");
                if (shouldAutoApplySub15) dispatch(updatePromotionCode("SUB15"));
                setSubscription(!!subscription);
                let params = {
                    timesRequested: pickedTimeSlot,
                    animalId: selectedPetId,
                    description: additionalInfo,
                    chatId: `${selectedPetId}`,
                    state: location === false ? null : location,
                    appointmentType: serviceType,
                    funnelEmailGiftId: !!schedulingReducer.funnelEmailGiftId ? schedulingReducer.funnelEmailGiftId : null,
                };
                if (!immediate && vetId) {
                    // @ts-ignore
                    params.vetUserId = vetId;
                }

                if (promoBranch && partnerId !== 13 && !subscription) {
                    // @ts-ignore
                    params.promotionCode = promoBranch;
                }
                if (shouldAutoApplySub15) {
                    // @ts-ignore
                    params.promotionCode = "SUB15";
                }
                if (paymentMethod === "WITH_REFERRAL_CODE") {
                    // @ts-ignore
                    params.referralCodeRequestId = user.referralCodeRequest.id;
                }

                if (invite || referralCash > 0) {
                    // @ts-ignore
                    params.useReferralCodeRequests = true;
                }
                api_getCreditPrices(location, [bundleType])
                    .then((prices) => {
                        setCreditsInfo(prices)
                        dispatch(setInvoicePreview(params))
                            .then(async (invoice) => {
                                const price = +invoice.charges[0].amount.split(" ")[1];
                                const service = invoice.charges.find(charge => charge.type === "APPOINTMENT_FEE").amount;
                                const servicePrice = +service.split(" ")[1];
                                setVetPrice(invoice.charges[0].amount);
                                if (typeof promoBranch === "string" && promoBranch) {
                                    const substracted = invoice.charges.find(charge => charge.type === "APPOINTMENT_FEE_PROMO_DISCOUNT" || charge.type === "SERVICE_FEE_PROMO_DISCOUNT" || charge.type === "TOTAL_PROMO_DISCOUNT")?.amount;
                                    setAmountSubtracted(substracted);
                                    const totalWithPromo = `USD ${(price + servicePrice).toFixed(2)}`;
                                    setTotalWithPromo(totalWithPromo);
                                    setWasPromoApplied(true);
                                }
                                switch (paymentMethod) {
                                    case "WITHOUT_CREDITS":
                                        setTotalPrice(invoice.totalAmount);
                                        break;
                                    case "WITH_CREDITS":
                                        setCreditPrice(invoice.totalAmount);
                                        setTotalPrice("USD 0.00");
                                        break;
                                    case "WITH_REFERRAL_CODE": {
                                        const referralSubstracted = invoice.charges.find(charge => charge.type === "REFERRAL_CODE")?.amount;
                                        const preTotal = `USD ${(Number(invoice.totalAmount.split(" ")[1]) - referralSubstracted.split(" ")[1]).toFixed(2)}`;
                                        setTotalWithPromo(preTotal);
                                        setMoneyApplied(referralSubstracted);
                                        setTotalPrice(invoice.totalAmount);
                                        break;
                                    }
                                    case "PURCHASE_BUNDLE":
                                        setCreditPrice(invoice.totalAmount);
                                        setTotalPrice(`USD ${Number(prices.find(({creditType}) => creditType === option)?.price.split(" ")[1].split(".")[0]).toFixed(2)}`);
                                        break;
                                }
                                if (referralCash > 0) {
                                    const referralSubstracted = invoice.charges.find(charge => charge.type === "REFERRAL_CODE")?.amount;
                                    const preTotal = `USD ${(Number(invoice.totalAmount.split(" ")[1]) - referralSubstracted.split(" ")[1]).toFixed(2)}`;
                                    setTotalWithPromo(preTotal);
                                    setMoneyApplied(referralSubstracted);
                                    setTotalPrice(invoice.totalAmount);
                                }
                                if (user.role !== "ADMIN" && total === 0) {
                                    const pet = await API.getAnimalById(selectedPetId);
                                    const specialty = getVetSpecialtyFromPet(pet);
                                    let requestBody = {
                                        animalId: selectedPetId,
                                        description: additionalInfo,
                                        chatId: Math.floor(Math.random() * 10001),
                                        timesRequested: formattedPickedTimeSlot,
                                        appointmentType: serviceType,
                                        vetSpecialty: specialty,
                                    };
                                    if (wasPromoApplied) {
                                        // @ts-ignore
                                        requestBody.promotionCode = promo;
                                    }
                                    if (!immediate) {
                                        // @ts-ignore
                                        requestBody.vetUserId = vetId;
                                    }
                                    if (paymentMethod === "WITH_CREDITS") {
                                        const requests = await dispatch(getCreditRequests(bundleType));
                                        // @ts-ignore
                                        requestBody.creditRequestId = requests[0]?.id;
                                    } else {
                                        // @ts-ignore
                                        requestBody.paymentRequest = {
                                            type: "square",
                                            amount: "USD 0.00",
                                            nonce: "no nonce needed"
                                        };
                                    }
                                    try {
                                        const apptRequest = await dispatch(postAppointmentRequest(requestBody));
                                        if (paymentMethod === "WITH_CREDITS") dispatch(reduceCreditsCount());
                                        history.push({
                                            pathname: "/appointmentConfirmation",
                                            state: {
                                                appointmentId: apptRequest.appointmentId,
                                                total: "0",
                                                type: apptRequest.appointmentType,
                                            }
                                        });
                                    } catch (err) {
                                        console.log("postAppointmentRequest error: ", err);
                                    }
                                }
                                setIsInitialDataFetched(true);
                            }).catch((err) => {
                            setIsLoading(false);
                            enqueueSnackbar(err.message, {variant: "error"});
                            setIsInitialDataFetched(false);
                        }).finally(() => {
                            setIsLoading(false);
                            if ((promo || promotionCode) && subscription === false && partnerId !== 13) {
                                applyPromo(true);
                            }
                        });
                    })
            }
        })();
    }, [paymentMethod]);


	const setAppointmentData = ()=>{
		dispatch(setIsCreditPayment(true));
		dispatch(changeAppointmentData({promo: promo,
			isAgree: true,
			vetPrice: vetPrice}));
	}

    useEffect(()=>{
        if(!!isCreditPayment){
            setPromo(appointmentData.promo);
            setVetPrice(appointmentData.vetPrice);
            dispatch(setIsCreditPayment(false))
        }
    }, [])
    useEffect(()=>{
        if(!!promo){
            applyPromo(true)
        }
    }, [isCreditPayment])

    const applyPromo = (isApplied) => {
        setIsLoading(true);
        if (promo === "CARROLL") {
            if (vetId !== 3294) {
                enqueueSnackbar("This promo is only eligible for appointments with Dr. Carroll", {
                    variant: "error",
                    autoHideDuration: 3000
                });
                setIsLoading(false);
                return;
            }
            if (!["ADVICE_CHAT", "ADVICE_VIDEO"].includes(serviceType)) {
                enqueueSnackbar("This promo is only for advice appointments", {
                    variant: "error",
                    autoHideDuration: 3000
                });
                setIsLoading(false);
                return;
            }
        }
        setMoneyApplied(null);
        if (!hasSubscription) {
            dispatch(updatePaymentMethod("WITHOUT_CREDITS"));
        }
        setPromoApplied(isApplied ? "" : promo);
        if (isApplied) setPromo("");
        let params = {
            timesRequested: pickedTimeSlot,
            animalId: selectedPetId,
            description: additionalInfo,
            chatId: `${selectedPetId}`,
            state: location === false ? null : location,
            appointmentType: serviceType,
            promotionCode: isApplied ? "" : promo,
            funnelEmailGiftId: !!schedulingReducer.funnelEmailGiftId ? schedulingReducer.funnelEmailGiftId : null
        };
        if (!immediate && vetId) {
            // @ts-ignore
            params.vetUserId = vetId;
        }
        dispatch(setInvoicePreview(params))
            .then((invoice) => {
                setVetPrice(invoice.charges[0].amount || "");
                const substracted = invoice?.charges.find(charge => charge.type === "APPOINTMENT_FEE_PROMO_DISCOUNT" || charge.type === "SERVICE_FEE_PROMO_DISCOUNT" || charge.type === "TOTAL_PROMO_DISCOUNT")?.amount || "";
                setAmountSubtracted(substracted);
                const totalWithPromo = !substracted ? "" : `USD ${(Number(vetPrice.split(" ")[1]) - Number(substracted?.split(" ")[1]?.slice(1)))?.toFixed(2)}`;
                setTotalWithPromo(totalWithPromo);
                setTotalPrice(invoice.totalAmount || "");
                setIsInitialDataFetched(true);
                setWasPromoApplied(isApplied ? false : true);
                dispatch(updatePromotionCode(isApplied ? "" : promo));
            }).catch((err) => {
                setPromo("");
                dispatch(updatePromotionCode(""));
                setIsInitialDataFetched(true);
                setMoneyApplied("");
                setPromoApplied("");
                delete params.promotionCode;
                enqueueSnackbar(err.errorMessage, {variant: "error", autoHideDuration: 3000,});
            }).finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        if (acknowledgedCall) {
            if (reasonType === "PRESCRIPTION") {
                optionalCheckboxValue ? setIsButtonDisabled(false) : setIsButtonDisabled(true);
            }
            else {
                setIsButtonDisabled(false);
            }
        } else {
            setIsButtonDisabled(true);
        }
    }, [optionalCheckboxValue, promo, acknowledgedCall, pickedTimeSlot]);

    useEffect(() => {
        if (promo.length) {
            setIsPromoButtonDisabled(false);
        } else {
            setIsPromoButtonDisabled(true);
        }
    }, [promo]);

    return (
        <Container className={classes.containerWrapper} maxWidth="md">
            <Card variant="outlined" style={{padding: 20}}>
                <Typography variant="h2" ref={myRef} gutterBottom>Appointment Summary</Typography>
                {
                    isInPast &&
                    <Box className={classes.newTimeSlot}>
                        <Typography variant="body2">
                            The appointment time was updated
                            to {moment(schedulingReducer.pickedTimeSlot[0]).format("LL")} at {moment(schedulingReducer.pickedTimeSlot[0]).format("LT")}.
                            We apologize for any inconvenience!
                        </Typography>
                    </Box>

                }
                <Typography variant="h4"
                    gutterBottom style={{wordBreak: "break-word"}}>For {petName} on {moment(schedulingReducer.pickedTimeSlot[0]).format("LL")} at {moment(schedulingReducer.pickedTimeSlot[0]).format("LT")}</Typography>
                <Card variant="outlined" style={{height: "100px", width: "300px"}}>
                    <Grid container justify="center" alignItems="center">
                        <Grid item xs={4}>
                            {
                                schedulingReducer["vetProfile"]["image"] ?
                                    <Image alt="vet image" imageStyle={{objectFit: "cover", width: "98px", height: "98px"}}
                                        src={schedulingReducer["vetProfile"]["image"]} errorIcon={<DocSVG/>}/>
                                    :
                                    <Box width="80px" height="80px">
                                        <DocSVG/>
                                    </Box>
                            }
                        </Grid>
                        <Grid item xs={8} alignItems="center" justify="center">
                            <Typography style={{marginLeft: "10px"}} variant="h6">Dr. {schedulingReducer.vetProfile["lastName"]}</Typography>
                            <Typography style={{marginLeft: "10px"}}>{setType(serviceType)}</Typography>
                        </Grid>
                    </Grid>
                </Card>
                <Divider variant="middle" style={{marginTop: 25, marginBottom: 25}}/>
                {isLoading ?
                    <Box width="100%" height="150px" display="flex" justifyContent="center" alignItems="center">
                        <CircularProgress/>
                    </Box>
                    :
                    <>
                        <>
                            <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                <Typography variant="h5">
                                    Description
                                </Typography>
                                <Typography variant="h5">
                                    Amount
                                </Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                <Typography>
                                    Price
                                </Typography>
                                <Typography>
                                    {vetPrice}
                                </Typography>
                            </Box>
                            {
                                wasPromoApplied &&
                                <>
                                    <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                        <Typography>
                                            Promo applied
                                        </Typography>
                                        <Typography>
                                            {amountSubtracted}
                                        </Typography>
                                    </Box>
                                    {totalPrice != "USD 0.00" ?
                                        <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                            <Typography style={{fontWeight: 700}}>
                                                Pre-Promo Total
                                            </Typography>
                                            <Typography style={{fontWeight: 700}}>
                                                {totalWithPromo}
                                            </Typography>
                                        </Box> : null}
                                </>
                            }
                            {
                                moneyApplied &&
                                <>
                                    <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                        <Typography>
                                            Referral applied
                                        </Typography>
                                        <Typography>
                                            ({`${moneyApplied}`})
                                        </Typography>
                                    </Box>
                                </>
                            }
                            {
                                (partnerId !== 13 && (paymentMethod === "WITH_CREDITS" || paymentMethod === "PURCHASE_BUNDLE")) &&
                                <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                    <Typography>
                                        1 Appointment Used
                                    </Typography>
                                    <Typography>
                                        ({creditPrice})
                                    </Typography>
                                </Box>
                            }
                            {
                                paymentMethod === "PURCHASE_BUNDLE" &&
                                <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                    <Typography>
                                        Credit Bundle Purchase
                                    </Typography>
                                    <Typography>
                                        USD {Number(creditsInfo.find(({creditType}) => creditType === option)?.price.split(" ")[1].split(".")[0]).toFixed(2)}
                                    </Typography>
                                </Box>
                            }
                            <Box display="flex" justifyContent="space-between" marginBottom="15px">
                                <Typography style={(wasPromoApplied || moneyApplied) ? {fontWeight: 700} : {}}>
                                    Total
                                </Typography>
                                <Typography style={(wasPromoApplied || moneyApplied) ? {fontWeight: 700} : {}}>
                                    {totalPrice}
                                </Typography>
                            </Box>
                        </>
                        {(paymentMethod === "WITHOUT_CREDITS" || paymentMethod === "WITH_REFERRAL_CODE") && referralMoney === 0 && subscription === false && partnerId !== 13
                        &&
                        <Grid container alignItems="center" justify="space-between" className={classes.promo}>
                            <Grid item xs={8}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Add Promo Code"
                                    inputProps={{className: classes.input}}
                                    value={promo}
                                    disabled={promoApplied ? true : false}
                                    onChange={(event) => setPromo(event.target.value.toUpperCase())}
                                />
                            </Grid>
                            <Grid item xs="auto" justify="flex-end">
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    className={classes.promoBtn}
                                    disabled={isPromoButtonDisabled}
                                    onClick={() => {promoApplied ? applyPromo(true) : applyPromo(false)}}
                                >{!promoApplied ? "Apply" : "Clear"}</Button>
                            </Grid>
                        </Grid>
                        }
                        <Divider variant="middle" style={{marginTop: 25, marginBottom: 25}}/>
                        <Typography variant="h5">Acknowledgements</Typography>
                        {
                            reasonType == "PRESCRIPTION" &&
                            <Box display="flex" marginTop="10px" alignItems="center">
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder/>}
                                    value={optionalCheckboxValue}
                                    onChange={() => {
                                        setoptionalCheckboxValue(!optionalCheckboxValue);
                                    }}
                                    disabled={!isInitialDataFetched}
                                />
                                <Box>
                                    <Typography>I acknowledge that the veterinarian reserves the right to refuse to prescribe
                                        medication if he/she feels that it could potentially be harmful to the pet. I understand that my pet
                                        must be present in the video.</Typography>
                                </Box>
                            </Box>
                        }
                        {
                            serviceType == "IMMEDIATE_CHAT" &&
                            <Box display="flex" marginTop="10px" alignItems="center">
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder/>}
                                    value={optionalCheckboxValue}
                                    onChange={() => {
                                        setoptionalCheckboxValue(!optionalCheckboxValue);
                                    }}
                                    disabled={!isInitialDataFetched}
                                />
                                <Box>
                                    <Typography>
                                        {immediate ?
                                            "I acknowledge that this is for advice and next steps and will not result in a prescription." :
                                            "I acknowledge that this is for advice and triage."
                                        }
                                    </Typography>
                                </Box>
                            </Box>
                        }
                        <Box display="flex" marginTop="10px" alignItems="center">
                            <Checkbox
                                color="secondary"
                                icon={<CheckboxBorder/>}
                                value={acknowledgedCall}
                                onChange={() => {
                                    setAcknowledgedCall(!acknowledgedCall);
                                }}
                                disabled={!isInitialDataFetched}
                            />
                            <Box>
                                <Typography>
                                    I understand that this appointment is not a phone call. I must log in to the platform
                                    and join by clicking on the Appointments tab.
                                </Typography>
                            </Box>
                        </Box>
                        {!isWhiteLabel && pcv === "yes" &&
                        <Box display="flex" marginTop="10px" alignItems="center">
                            <Checkbox
                                color="secondary"
                                icon={<CheckboxBorder/>}
                                value={pcvCheckBoxValue}
                                onChange={() => {
                                    setPCVCheckBoxValue(!pcvCheckBoxValue);
                                }}
                                disabled={!isInitialDataFetched}
                            />
                            <Box>
                                <Typography>
                                    I authorize The Video Vets to release the appointment notes from this appointment to the
                                    primary care vet listed in my pet's profile. (Optional)
                                </Typography>
                            </Box>
                        </Box>
                            }
                    </>}
                <Divider variant="middle" style={{marginTop: 25, marginBottom: 25}}/>
                <Typography variant="h5" style={{paddingBottom: 20}}>Payment Method</Typography>
                {paymentMethod !== "WITH_CREDITS" && totalPrice !== "USD 0.00" ? (
                    <PaymentForm
                        price={total}
                        purchaseType={paymentMethod === "PURCHASE_BUNDLE" ? "bundlePurchase" : "appointmentPurchase"}
                        disabled={isButtonDisabled || isLoading || isRequestFinish}
						// cards={selectedCard}
                        setIsRequestFinish={setIsRequestFinish}
						setAppointmentData={setAppointmentData}
                        setDisabled={setIsButtonDisabled}
                        pcvCheckBoxValue={pcvCheckBoxValue}
                        referralInvite={referralInvite}
                        withSaveForNext={!cards.length}
                        invitation={invitation}
                        checkTimeslot={checkTimeslot}
                        isInPast={isInPast}
                        setIsInPast={setIsInPast}
                        myRef={myRef}
                    />
                ) : (
                    <Button type="button" variant="contained" onClick={handleButtonClick} fullWidth color="secondary"
                        disabled={isButtonDisabled || isRequestFinish}>
                        {
                            (subscription && ["ADVICE_CHAT", "ADVICE_VIDEO"].includes(serviceType)) || partnerId === 13
                                ?
                                "Request Appointment"
                                :
                                "Complete payment"
                        }
                    </Button>
                )}
                {!immediate &&
                <>
                    <Box marginTop="15px" marginBottom="15px">
                        <Typography variant="h3">
                            Refund Policy
                        </Typography>
                    </Box>
                    <Typography>
                        Cancellations that occur at least 24 hours before an appointment begins are eligible for a refund. Cancellations that occur less than 24 hours before an appointment begins are eligible for a credit towards future visits.
                    </Typography>
                </>}
            </Card>
        </Container>
    );
};

export default InvoiceAppointment;
